import client from './client'
import swal from './sweetalert2'
import vuetify from './vuetify'
import './vueSignaturePad'

export default {
  client,
  swal,
  vuetify
}
